import { useAppStoreHref } from "@axqora/ui";
import { siteConfig } from "../config";
import type { Locale } from "../content/types";

type AppStoreButtonProps = {
  label: string;
  unavailableLabel: string;
  locale: Locale;
};

export function AppStoreButton({ label, unavailableLabel, locale }: AppStoreButtonProps) {
  const href = useAppStoreHref(siteConfig.appStoreUrl[locale], locale);
  if (!href) {
    return (
      <span className="app-store-button app-store-button-disabled" aria-disabled="true">
        {unavailableLabel}
      </span>
    );
  }

  return (
    <a className="app-store-button" href={href} target="_blank" rel="noreferrer" aria-label={label}>
      {label}
    </a>
  );
}
